import React, { forwardRef } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

interface IProps {
  label: string | null;
  type?: string;
  error?: boolean;
  helperText?: string | null;
  defaultValue?: string;
  multiple?: boolean;
  /* eslint-disable-next-line */
  value: any;
  selectOptions: { value: string; label: string }[];
}

const TogglerButtonInput = forwardRef(
  (
    {
      label = null,
      type = 'text',
      error,
      helperText,
      selectOptions = [],
      defaultValue = '',
      multiple,
      value,
      ...other
    }: IProps,
    ref
  ) => {
    return (
      <FormControl
        variant="standard"
        fullWidth
        error={error}
        sx={{ margin: '12px 0' }}
      >
        {label && (
          <InputLabel
            shrink
            disableAnimation={true}
            htmlFor="demo-customized-toggle-button"
            sx={{
              color: '#5E6366',
              pl: 1,
              '&.Mui-focused': {
                color: error ? '#F9473C' : '#5E6366 !important',
              },
            }}
          >
            {label}
          </InputLabel>
        )}

        <ToggleButtonGroup
          
          id="demo-customized-toggle-button"
          defaultValue={defaultValue}
          aria-label="Platform"
          sx={[
            helperText
              ? {
                marginTop:'20px',
                  boxShadow: (theme) =>
                    `${alpha(theme.palette.error.main, 0.5)} 0 0 0 0.2rem`,
                  borderColor: (theme) => theme.palette.error.main,
                  borderRadius: '8px',
                }
              : {
                marginTop:'25px',
                width:'100%',
                display:'flex',
              },
          ]}
          value={value}
          {...other}
          ref={ref}
        >
          {selectOptions?.map((op, index) => {
            return (
              <ToggleButton
                sx={{
                  flex: 1,
                  border: '1px solid #5E6366',
                  '&.Mui-selected, &.Mui-selected:hover': {
                    color: 'white',
                    backgroundColor: '#103c55',
                  },
                }}
                key={`button_${op.value}_${index}`}
                value={op.value}
              >
                {op.label}
              </ToggleButton>
            );})
          }
        </ToggleButtonGroup>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default TogglerButtonInput;
